'use client';

import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { constructQuery } from '@repo/shared/helpers';
import LogsTab from 'src/parts/tabs/LogsTab';
import { getGroupLogs } from 'src/api/personal/groupDetail';
import { startOfDay, subMonths, endOfDay } from 'date-fns';
export const Route = createFileRoute('/personal_/groups/$groupId/logs')({
	validateSearch: (search: Record<string, unknown>) => {
		const now = new Date();
		return {
			from: (search.from as string) || startOfDay(subMonths(now, 1)).toISOString(),
			until: (search.until as string) || endOfDay(now).toISOString(),
			page: (search.page as number) || undefined,
			sort: (search.sort as string) || undefined,
		};
	},
	loaderDeps: ({ search }) => search,
	loader: async ({ params, deps }) => {
		const query = constructQuery({
			from: deps.from,
			until: deps.until,
			page: deps.page,
			sort: deps.sort || 'timestamp:desc',
		});
		const logs = await getGroupLogs(params.groupId, query);
		return { logs };
	},
	component: LogsPage,
});

function LogsPage() {
	const { groupId } = Route.useParams();
	const searchParams = Route.useSearch();
	const { logs: initialLogs } = Route.useLoaderData();

	const query = constructQuery({
		from: searchParams.from,
		until: searchParams.until,
		page: searchParams.page,
		sort: searchParams.sort || 'timestamp:desc',
	});
	const { data: logs, refetch: refetchLogs } = useQuery({
		queryKey: [
			'personal-group-logs',
			groupId,
			searchParams.from,
			searchParams.until,
			searchParams.page,
			searchParams.sort,
		],
		queryFn: () => getGroupLogs(groupId, query),
		initialData: initialLogs,
	});

	const handleReload = () => {
		refetchLogs();
	};

	return <LogsTab showFilter={false} logs={logs} logType="GroupLog" onReload={handleReload} />;
}
